// Centralized API base URL configuration
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081';

export default BASE_URL;
